/**
 * CorporateOfficeSearch JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;
const Officesearch = require( './officesearch' );

/**
 * Class CorporateOfficeSearch
 */
class CorporateOfficeSearch extends Officesearch {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {
        super();
    }

    /**
     *  This gets search results
     *
     */
    getResults( searchstring ) {

        // Empty possible old results, show spinner and dropdown
        this.results.empty();
        this.spinner.addClass( 'office-search__spinner--visible' );
        this.dropdown.addClass( 'office-search__result-wrapper--visible' );

        dp( 'PageCorporateContact/GetOffices', {
            partial: 'corporateofficesearchresult',
            'args': {
                searchstring
            }
        }).then( data => {

            // Hide spinner and show data rendered with dust partial
            this.spinner.removeClass( 'office-search__spinner--visible' );
            this.results.html( data.success );
            window.addEventListener( 'click', this.handleClickOutside );
        }).catch( error => {
            this.spinner.removeClass( 'office-search__spinner--visible' );
            this.results.html( '<div class="office-search__error"><p>Haku ei onnistunut</p></div>' );
            console.log( error );
        });
    }

}

// Export the class reference.
module.exports = CorporateOfficeSearch;



// WEBPACK FOOTER //
// ./assets/scripts/corporateofficesearch.js